"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tsm_1 = require("@tlaukkan/tsm");
var Store_1 = __importDefault(require("../Store"));
function getCameraForPos(pos, currentPos, bias) {
    var envInfo = Store_1.default.getState().EnvironmentInfo;
    if (envInfo) {
        var car = envInfo.mastermodel;
        var id = [car.manufacturer, car.model, car.year].join(" ");
        var cardata = envInfo.vehicle;
        //console.log("getcameraforpos", car, cardata);
        //console.log("CAMERA::ENVINFO");
        if (cardata !== undefined && Object.keys(cardata).length > 0) {
            var carmeta = cardata[id] || Object.values(cardata[0]);
            //console.log("carmeta", carmeta);
            //console.log("CAMERA::CARMETA");
            if (carmeta.metadata && carmeta.metadata.cameras) {
                var cam = Object.values(carmeta.metadata.cameras).find(function (c) { return c.id === window.zlbolt.getCamera(); });
                if (cam && cam["2DOD"] && !cam.interior) {
                    var samples = cam["2DOD"].samples;
                    if (samples) {
                        //console.log("samples", samples);
                        var dist = -1;
                        var index = -1;
                        //console.log("CAMERA::SAMPLES");
                        //console.log("CAMERA:: ", bias, currentPos);
                        for (var s = 0; s < samples.length; s++) {
                            var ss = samples[s];
                            var sv = new tsm_1.vec3([ss.posx, ss.posy, ss.posz]);
                            var d = sv.subtract(pos).length();
                            if (bias && currentPos) {
                                if (bias === "z") {
                                    // item(s) is larger in the z axis so account for a camera to show this
                                    var rhs = false;
                                    var dpRight = tsm_1.vec3.dot(currentPos.normalize(), new tsm_1.vec3([1, 0, 0]));
                                    var dpLeft = tsm_1.vec3.dot(currentPos.normalize(), new tsm_1.vec3([-1, 0, 0]));
                                    // determine which side camera (LHS or RHS of vehicle) to use based on our curr cam position
                                    if (dpRight > dpLeft) {
                                        rhs = true;
                                    }
                                    var leftDist = new tsm_1.vec3([-5, 0, 0]).subtract(pos).length();
                                    var rightDist = new tsm_1.vec3([5, 0, 0]).subtract(pos).length();
                                    var absDiff = Math.abs(leftDist - rightDist);
                                    if (absDiff > 0.6) {
                                        if (leftDist < rightDist) {
                                            // item is on left side of vehicle so move to cam over there
                                            rhs = false;
                                        }
                                        else {
                                            // item is on right side of vehicle so move to cam over there
                                            rhs = true;
                                        }
                                    }
                                    // if camera is directly behind vehicle or at the opposite side then do not use as we want to show more of a side profile
                                    if (!((rhs && sv.x > 0) || (!rhs && sv.x < 0))) {
                                        d = 999;
                                    }
                                }
                            }
                            if (dist < 0 || d < dist) {
                                index = s;
                                dist = d;
                            }
                        }
                        if (index >= 0) {
                            var si = samples[index];
                            if (currentPos) {
                                // if a current pos was passed in, don't move the camera if the new position is less than 1m away
                                var target = new tsm_1.vec3([si.posx, si.posy, si.posz]);
                                //let startPos = currentPos.copy();
                                var vec = currentPos.subtract(target);
                                var targetDist = vec.length();
                                var dp = tsm_1.vec3.dot(currentPos, target);
                                var magCurr = currentPos.length();
                                var magTarg = target.length();
                                var angle = Math.acos(dp / (magCurr * magTarg));
                                // if angle is ~28Deg different then apply switch 
                                if (angle > 0.5 || pos === currentPos) {
                                    return { cam: si, dist: targetDist };
                                }
                                else {
                                    console.log("was already close, not moving");
                                }
                            }
                            else {
                                return { cam: si, dist: -1 };
                            }
                        }
                    }
                }
            }
        }
    }
    return undefined;
}
exports.default = getCameraForPos;
/*
declare global {
    interface Window { test: any}
}

window.test = function(x: number, y: number, z: number){
    return getCameraForPos(new vec3([x, y, z]));
}
/**/ 
//# sourceMappingURL=camera.js.map